import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import ImageSlider
 from "../pages/imgslider";
const defaultIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png"
});


const customIcon = new L.Icon({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41], // <-- ancora in basso al centro
  popupAnchor: [0, -41],
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [41, 41],
  shadowAnchor: [12, 41]
});
L.Marker.prototype.options.icon = customIcon;

export default function MapComponent({ poiData }) {
  return (
    <MapContainer center={[41.8902, 12.4922]} zoom={5} style={{ height: "600px", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      {poiData.map((poi, idx) => (
          <Marker key={idx} position={[poi.lat, poi.lng]}>
          <Popup>
            
            <ImageSlider poi={poi} />
            
            <a href={poi.link} target="_blank">
            <strong>{poi.nome}</strong><br />
            </a>
            {poi.ldescrizione}<br />
            <em>{poi.indirizzo}</em><br /> 
            {/*
             {poi.layers && poi.layers.length > 0 && ( <em>Risorse Gis:</em>)}
             {poi.layers && poi.layers.length > 0 && (
                <ul className="mt-2 list-disc list-inside">
                  
                  {poi.layers.map((layer, i) => (
                    <li key={i}>
                      <a href={layer.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                        {layer.nome}
                      </a>
                    </li>
                  ))}
                  
                </ul>
              )}
              */}
              { poi.bimobj.length  >0 && 
                (<a href={"/objinfo/"+poi.id_luogo} rel="noopener noreferrer">Altre Risorse</a>
                )
                }

          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
